import { render, staticRenderFns } from "./TrxEx_Export.vue?vue&type=template&id=45153f00"
import script from "./TrxEx_Export.vue?vue&type=script&lang=js"
export * from "./TrxEx_Export.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports